const { getCouponDiscount } = require('./coupons')

function getPriceVariation (model, guests) {
  if (!model) {
    return
  }

  const { variations } = model.price
  if (!variations) {
    return
  }

  const variation = variations.find(({ from, to }) => {
    const checkFrom = from ? from <= guests : true
    const checkTo = to ? to >= guests : true

    return checkFrom && checkTo
  })

  return variation
}

// TODO: take a deep look into this function
function getReservationAmounts (reservation, coupon, event, model) {
  const { guests, extras = [] } = reservation
  const { price: { value: priceValue, mode: priceMode }, payment } = event

  const variation = getPriceVariation(model, guests)
  const baseAmount = priceMode === 'event'
    ? priceValue
    : priceValue * guests
  const basePricePerGuest = baseAmount / guests
  const variationAmount = variation
    ? variation.value * guests
    : 0
  const variationPerGuest = variation
    ? variation.value
    : 0
  const extrasAmount = extras.length
    ? extras.reduce((acc, { price, quantity }) => acc + price * quantity, 0)
    : 0
  const extrasPerGuest = extrasAmount / guests
  const total = baseAmount + variationAmount + extrasAmount
  const { amount, off, left } = getCouponDiscount(coupon, { price: basePricePerGuest, guests, total })

  return {
    priceValue,
    baseAmount,
    basePricePerGuest,
    variationAmount,
    variationPerGuest,
    extrasAmount,
    extrasPerGuest,
    total,
    amount,
    prepaidAmount: amount * payment.amounts[0],
    off,
    left,
  }
}
exports.getReservationAmounts = getReservationAmounts

function processExtras (model, body) {
  const { extras: modelExtras = [] } = model
  const { extras: bodyExtras = {} } = body
  const reservationExtras = []

  for (const extraId in bodyExtras) {
    const modelExtra = modelExtras.find((e) => e.extra._id.toString() === extraId)
    if (!modelExtra) {
      continue
    }

    const { price } = modelExtra.extra
    reservationExtras.push({
      extra   : extraId,
      quantity: body.extras[extraId],
      price,
    })
  }

  return reservationExtras
}
exports.processExtras = processExtras
